<template>
    <div class="container">
        <div class="page-content">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading">
                        {{ $t('shop.title') }}
                    </h1>
                </div>

                <div class="col-12 mb-4" v-if="$store.state?.user?.todays_purchased_booster_count > 0">
                    <div class="mb-0">
                        <span style="font-size: 1.2em;" class="me-2">{{ $store.state.user.todays_purchased_booster_count }} / 100</span>
                        <small class="muted">{{ $t('shop.limitationInfo') }}</small>
                    </div>
                    <div class="progress rounded">
                        <div class="progress-bar progress-bar-striped bg-info progress-bar-animated rounded" role="progressbar" :aria-valuenow="$store.state.user.todays_purchased_booster_count" aria-valuemin="0" aria-valuemax="100" :style="'width: '+$store.state.user.todays_purchased_booster_count+'%;'"></div>
                    </div>
                </div>

                <div class="col-12 mb-0" style="white-space: nowrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation" v-on:click="tab = 'specials'">
                            <h5 class="nav-link active" id="specials-tab" data-bs-toggle="tab" data-bs-target="#tab" type="button" role="tab" aria-controls="home" aria-selected="true">
                                {{ $t('shop.tabs.specials') }}
                            </h5>
                        </li>

                        <li class="nav-item" role="presentation" v-on:click="tab = 'sets'">
                            <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#tab" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                {{ $t('shop.tabs.sets') }}
                            </h5>
                        </li>

                        <li v-if="$store.state?.user?.isAdmin" class="nav-item" role="presentation" v-on:click="tab = 'decks'">
                            <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#tab" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                {{ $t('shop.tabs.decks') }}
                            </h5>
                        </li>
                    </ul>
                </div>

                <div class="col-12 mb-4" v-if="tab === 'specials'">
                    <div class="mt-1 pb-1">
                        <small class="muted float-end">{{ $t('shop.refreshesInfo') }} {{ getNextShopRefreshCooldown() }}</small>
                    </div>

                    <div class="mt-2 mb-5" v-for="key in Object.keys($store.state.shopTodaysOffers)">
                        <h3 class="mb-1 mt-3">{{ $t('shop.headings.'+key) }}</h3>
                        <div class="todays-collection-wrapper">
                            <div class="card mb-3 my-1 bg-black text-white todays-collection" v-if="$store.state.shopTodaysOffers.collections" v-for="shopItem in $store.state.shopTodaysOffers[key]">
                                <h5 class="text-center mt-3 mb-0 pt-0 px-4" v-text="shopItem.name"></h5>
                                <div class="row g-0">
                                    <a class="col-md-12 text-center align-content-center" :data-lightbox="shopItem.id" :href="getAssetForShopItem(shopItem)">
                                        <img loading="lazy" :src="getAssetForShopItem(shopItem)" class="img-fluid rounded-start collection-product-image" v-on:click="checkForItemAction(shopItem)" alt="collection-product-image">
                                    </a>

                                    <div class="col-md-12">
                                        <div class="card-body h-100">
                                            <div class="card-text text-center collection-info row">
                                                <div class="pt-0">
                                                    <div v-if="shopItem.booster_count > 0 || shopItem.included_foreign_boosters || shopItem.includedCards.length > 0" class="collection-card-wrapper">
                                                        <a href="javascript:"
                                                           v-for="includedCard in shopItem.includedCards"
                                                           v-on:click="showCardCanvas(includedCard)"
                                                           :style="'background-image: url('+CardService.getSmallCardImageUrl(includedCard)+')'"
                                                           class="collection-card-preview rounded">
                                                        </a>

                                                        <a href="javascript:"
                                                           v-if="shopItem.booster_count"
                                                           :style="'background-image: url('+CardService.getRandomBoosterPackShotBySetId(shopItem.set_id)+')'"
                                                           class="collection-booster-preview">
                                                            <span class="badge">
                                                                {{ shopItem.booster_count }}
                                                            </span>
                                                        </a>

                                                        <a href="javascript:"
                                                           v-if="shopItem.included_foreign_boosters"
                                                           v-for="booster in shopItem.included_foreign_boosters.split(';')"
                                                           :style="'background-image: url('+CardService.getRandomBoosterPackShotBySetId(booster.split(':')[0])+')'"
                                                           class="collection-booster-preview">
                                                            <span class="badge">
                                                                {{ booster.split(':')[1] ?? '' }}
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div class="col-12 mt-3 mb-1 py-0">
                                                    <a href="javascript:" class="btn btn-light text-dark mt-0" v-on:click="purchaseItem(shopItem)" v-on:contextmenu.prevent="console.log(shopItem)"
                                                       v-if="!cooldownActive(shopItem)" style="width: 100% !important;">
                                                        {{ shopItem.price }} <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon">
                                                    </a>

                                                    <div v-if="cooldownActive(shopItem)">
                                                        <a href="javascript:" class="btn btn-light text-dark mt-0" disabled style="width: 100% !important;">
                                                            {{ $t('shop.wait')}} {{ getDiffInMinutes(shopItem) }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-1" v-if="tab === 'sets'">
                    <div class="row my-2 mb-3">
                        <div class="col mb-3 ps-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'en' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='en'">EN <img src="/assets/dipocaco/icons/en.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'ja' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='ja'">JA <img src="/assets/dipocaco/icons/ja.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'de' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='de'">DE <img src="/assets/dipocaco/icons/de.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3 pe-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'cn' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='cn'">CN <img src="/assets/dipocaco/icons/cn.png" alt="" class="language-icon"></a>
                        </div>

                        <div class="col mb-3 pe-0">
                            <a href="javascript:" :class="'px-0 btn btn-sm '+(setFilter === 'tcgp' ? 'btn-success' : 'btn-dark')+' w-100'" v-on:click="setFilter ='tcgp'">TCGP</a>
                        </div>
                    </div>

                    <h4 class="mb-2 ms-2"></h4>
                    <template v-for="series in $store.state.shopInventory">
                        <div v-show="setFilter === 'tcgp' ? series.name === 'Trading Card Game Pocket' : (series.language === setFilter && series.name !== 'Trading Card Game Pocket')">
                            <div class="row px-0">
                                <div class="col-12">
                                    <h5 class="series-name-heading float-end" :id="series.name.replaceAll(' ', '_').toLowerCase()">{{ series.name }}</h5>
                                </div>

                                <div class="col-12 p-0">
                                    <div class="row mb-1 p-0">
                                        <template v-for="set in series.sets">
                                            <div class="col-xxl-6 col-xl-6 col-xl-6 col-12 p-1 mb-2">
                                                <a :class="'card set-banner px-4 py-3'+(set.levelRequirement > $store.getters.level ? ' shop-item-image-locked' : '')" :style="'background-image: url(/assets/dipocaco/sets/'+set.set_id+'/logo.png);'" data-bs-toggle="collapse" :href="'#collapse'+set.set_id" :id="set.set_id">
                                                    <h5 class="mt-1" :title="set.set_id">
                                                        {{ set.name }}
                                                        <small class="muted releasing-date" v-if="set.releaseDate"><br/>
                                                            {{  (!set.released ? 'Release ' : '') + set.releaseDate }}
                                                            <template v-if="collectionStatus[set.set_id]">
                                                                | <span v-if="collectionStatus[set.set_id]['is_complete'] === true"><i class="fa-solid fa-check-circle" style="color: limegreen"></i></span>
                                                                <span v-else v-text="collectionStatus[set.set_id]['collected']+'/'+collectionStatus[set.set_id]['total']"></span>
                                                            </template>
                                                        </small>
                                                    </h5>
                                                    <div class="shop-set-image" :style="'background-image: url(/assets/dipocaco/sets/'+set.set_id+'/logo.png)'"></div>
                                                </a>

                                                <div class="row collapse pt-3" :id="'collapse'+set.set_id">
                                                    <div class="col-xxl-4 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-6 text-center mb-4 p-0" v-for="shopItem in set.items" v-show="shallDisplayShopItem(shopItem, set.items)">
                                                        <div v-if="$store.getters.level >= shopItem.level_requirement" v-on:contextmenu="console.log(shopItem)">
                                                            <div v-if="shopItem.item_type === 'single-booster' && getSplitAssets(shopItem).length >= 2" class="shop-item-image-folder-wrapper">
                                                                <div class="shop-item-image-folder">
                                                                    <div class="booster-pack-container">
                                                                        <img :src="getSplitAssets(shopItem)[0]" alt="Booster Pack 1" class="shop-item-image booster-pack booster-left">
                                                                        <img v-if="getSplitAssets(shopItem).length > 1" :src="getSplitAssets(shopItem)[1]" alt="Booster Pack 2" class="shop-item-image booster-pack booster-center">
                                                                        <img v-if="getSplitAssets(shopItem).length > 2" :src="getSplitAssets(shopItem)[2]" alt="Booster Pack 3" class="shop-item-image booster-pack booster-right">
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div v-else v-on:click="checkForItemAction(shopItem)" class="shop-item-image" :style="'background-image: url('+getAssetForShopItem(shopItem)+')'"></div>

                                                            <a href="javascript:" class="btn btn-dark" v-on:click="purchaseItem(shopItem)"
                                                               v-if="!cooldownActive(shopItem) && set.released && set.isComplete && !$store.getters.boosterPurchaseLimitReached">
                                                                {{ shopItem.price }} <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon">
                                                            </a>

                                                            <div v-if="cooldownActive(shopItem) && !$store.getters.boosterPurchaseLimitReached">
                                                                <a href="javascript:" class="btn btn-dark" disabled>wait {{ getDiffInMinutes(shopItem) }}</a>
                                                            </div>

                                                            <div v-if="$store.getters.boosterPurchaseLimitReached">
                                                                <a href="javascript:" class="btn btn-dark" disabled>
                                                                    {{ $t('shop.limiReached') }}
                                                                </a>
                                                            </div>

                                                            <small class="item-description muted" v-text="getItemDescription(shopItem)"></small>
                                                        </div>

                                                        <div v-else v-on:contextmenu="console.log(shopItem)">
                                                            <div v-if="shopItem.item_type === 'single-booster' && getSplitAssets(shopItem).length >= 2" class="shop-item-image-folder-wrapper">
                                                                <div class="shop-item-image-folder shop-item-image-locked">
                                                                    <div class="booster-pack-container">
                                                                        <img :src="getSplitAssets(shopItem)[0]" alt="Booster Pack 1" class="shop-item-image booster-pack booster-left">
                                                                        <img v-if="getSplitAssets(shopItem).length > 1" :src="getSplitAssets(shopItem)[1]" alt="Booster Pack 2" class="shop-item-image booster-pack booster-center">
                                                                        <img v-if="getSplitAssets(shopItem).length > 2" :src="getSplitAssets(shopItem)[2]" alt="Booster Pack 3" class="shop-item-image booster-pack booster-right">
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div v-else v-on:click="checkForItemAction(shopItem)" class="shop-item-image shop-item-image-locked" :style="'background-image: url('+getAssetForShopItem(shopItem)+')'"></div>

                                                            <div class="btn btn-dark"><i class="fa-solid fa-lock"></i> LVL
                                                                {{ shopItem.level_requirement }}
                                                            </div>

                                                            <small class="item-description muted" v-text="getItemDescription(shopItem)"></small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="col-12" v-if="tab === 'decks'">
                    <h3 class="mb-1 mt-3">{{ $t('shop.headings.prepareToFight') }}</h3>

                    <div class="row p-0">
                        <div class="mt-1 col-12 p-0 deck-shop-wrapper">
                            <div v-for="deck in decks" class="card deck-card bg-black text-white">
                                <div class="card-body row text-center">
                                    <div class="col-12">
                                        <h5 class="mb-1" v-text="deck.name"></h5>

                                        <div class="mb-3 deck-type-list">
                                            <img v-for="type in deck.types.split(';')" :src="CardService.getTypeIcon(type)" alt="">
                                        </div>

                                        <a :href="deck.asset_url" :data-lightbox="deck.id" data-title="Product Image" class="d-block">
                                            <img :src="deck.asset_url" alt="deck product image" class="deck-product-image">
                                        </a>

                                        <a class="deck-cards-wrapper mt-4">
                                            <template v-for="card in deck.cards">
                                                <a :href="CardService.getCardImageUrl(card.card)" :data-lightbox="deck.id" :data-title="card.card.name">
                                                    <img :src="CardService.getSmallCardImageUrl(card.card)" alt="" class="rounded"/>
                                                    <span class="badge" v-if="card.quantity > 1">
                                                        {{ card.quantity }}
                                                    </span>
                                                </a>
                                            </template>
                                        </a>
                                    </div>

                                    <div class="col-12">
                                        <a href="javascript:" class="btn btn-light" v-on:click="purchaseDeck(deck)" v-if="!deck.is_owned">
                                            {{ deck.price }} <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon">
                                        </a>
                                        <a href="javascript:" class="btn btn-dark" v-else>
                                            {{ $t('shop.owned') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <card-detail-view-canvas v-if="promoCardToShow" :gallery="true" :card="promoCardToShow"></card-detail-view-canvas>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import iziToast from "izitoast";
import CardService from "../../CardService";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import NewsCarousel from "../parts/NewsCarousel.vue";

export default {
    name: "BoosterShop",
    computed: {
        CardService() {
            return CardService
        }
    },
    components: {NewsCarousel, CardDetailViewCanvas},
    data() {
        return {
            shopInventory: [],
            seriesList: {},
            specialSeriesList: {},
            loadingList: false,
            promoCardToShow: null,
            tab: 'specials',
            collectionStatus: {},
            setFilter: 'en',
            decks: [],
        }
    },
    mounted() {
        this.fetchShopItems();
        this.fetchDeckList();


        if (this.$route.params.filter) {
            this.setFilter = this.$route.params.filter;
        } else if (localStorage.getItem('dipocaco_set_filter')) {
            this.setFilter = localStorage.getItem('dipocaco_set_filter');
        }

        if (this.$route.params.tab) {
            document.querySelector('#'+this.$route.params.tab+'-tab').click()
            this.tab = this.$route.params.tab;
        }

        setInterval(() => {
            this.$forceUpdate()
        }, 1000)
    },
    watch: {
        setFilter(newVal, oldVal) {
            localStorage.setItem('dipocaco_set_filter', newVal)
        }
    },
    methods: {
        fetchShopItems() {
            this.$store.commit('updateUserData');
            this.$store.commit('fetchShopItems');
            this.fetchCollectionStatus();
        },
        getSplitAssets(shopItem) {
            if (shopItem.asset_url.search(';') > 0) {
                return shopItem.asset_url.split(';').map(a => {
                    return a.startsWith('/') ? a : '/'+a;
                });
            }

            return [(shopItem.asset_url.startsWith('/') ? shopItem.asset_url : ('/' + shopItem.asset_url))];
        },
        getAssetForShopItem(shopItem) {
            let packshots = this.getSplitAssets(shopItem);
            return packshots[Math.floor(Math.random() * packshots.length)];
        },
        getItemDescription(shopItem) {
            switch (shopItem.item_type) {
                case 'single-booster':
                    return this.$i18n.t('shop.items.single');
                case 'single-booster-4':
                    return this.$i18n.t('shop.items.single4');
                case 'single-booster-5':
                    return this.$i18n.t('shop.items.single5');
                case 'single-booster-6':
                    return this.$i18n.t('shop.items.single6');
                case 'single-booster-7':
                    return this.$i18n.t('shop.items.single7');
                case 'single-booster-20':
                    return this.$i18n.t('shop.items.single20');
                case 'single-booster-25':
                    return this.$i18n.t('shop.items.single25');
                case 'booster-bundle':
                    return this.$i18n.t('shop.items.bundle');
                case 'elite-trainer-box':
                    if (shopItem.promo_card) {
                        return this.$i18n.t('shop.items.etbWithPromo', {promo: shopItem.promo_card.name});
                    }

                    return this.$i18n.t('shop.items.etb');
                case 'booster-box':
                    return this.$i18n.t('shop.items.display');
                case 'single-blister':
                    if (shopItem.promo_card) {
                        return this.$i18n.t('shop.items.blisterWithOneAndPromo', {promo: shopItem.promo_card.name});
                    }

                    if (shopItem.included_cards?.split(';')?.length) {
                        return this.$i18n.t('shop.items.blisterWithOneAndXPromo', {promoCount: shopItem.included_cards.split(';').length});
                    }

                    return this.$i18n.t('shop.items.blisterWithOne');
                case 'duo-blister':
                    if (shopItem.promo_card) {
                        return this.$i18n.t('shop.items.blisterWithTwoAndPromo', {promo: shopItem.promo_card.name});
                    }

                    if (shopItem.included_cards?.split(';')?.length) {
                        return this.$i18n.t('shop.items.blisterWithTwoAndXPromo', {promoCount: shopItem.included_cards.split(';').length});
                    }

                    return this.$i18n.t('shop.items.blisterWithTwo');
                case 'triple-blister':
                    if (shopItem.promo_card) {
                        return this.$i18n.t('shop.items.blisterWithThreeAndPromo', {promo: shopItem.promo_card.name});
                    }

                    if (shopItem.included_cards?.split(';')?.length) {
                        return this.$i18n.t('shop.items.blisterWithThreeAndXPromo', {promoCount: shopItem.included_cards.split(';').length});
                    }

                    return this.$i18n.t('shop.items.blisterWithThree');
                case 'tin':
                case 'collection':
                case 'mixed-blister':
                    if (shopItem.promo_card) {
                        return this.$i18n.t('shop.items.mixedAndPromo', {boosterCount: shopItem.booster_count, promo: shopItem.promo_card.name});
                    } else if (shopItem.included_cards) {
                        return this.$i18n.t('shop.items.mixedAndXPromo', {boosterCount: shopItem.booster_count, promoCount: shopItem.included_cards.split(';').length});
                    } else {
                        return this.$i18n.t('shop.items.mixedBoosterOnly', {type: shopItem.item_type.toUpperCase(), boosterCount: shopItem.booster_count});
                    }
                case 'ultra-premium-collection':
                    return this.$i18n.t('shop.items.ultraPremium', {boosterCount: shopItem.booster_count, promoCount: shopItem.included_cards.split(';').length});
            }
        },
        purchaseItem(shopItem) {
            if (this.$store.state.user.credit < shopItem.price) {
                iziToast.warning({
                    position: 'center',
                    title: this.$i18n.t('shop.items.notEnoughCredits')
                });
                return false;
            }

            if (this.cooldownActive(shopItem)) {
                iziToast.warning({
                    position: 'center',
                    title: this.$i18n.t('shop.items.cooldownActive'),
                });
                return false;
            }

            axios.post('/api/shop/buy', {
                id: shopItem.id,
                special: shopItem.special,
            }).then(response => {
                if (response.status === 200) {
                    iziToast.success({
                        message: this.$i18n.t('shop.addedToInventory'),
                        position: 'topRight',
                        messageColor: 'black !important',
                    });

                    shopItem.cooldown_until = moment().add(shopItem.cooldown_in_minutes, 'minutes');
                    this.$store.commit('updateUserData');
                    this.$forceUpdate();
                }
            });
        },
        purchaseDeck(deck) {
            if (this.$store.state.user.credit < deck.price) {
                iziToast.warning({
                    position: 'center',
                    title: this.$i18n.t('shop.items.notEnoughCredits')
                });
                return false;
            }

            if (deck.is_owned) {
                iziToast.warning({
                    position: 'center',
                    title: this.$i18n.t('shop.items.deckAlreadyOwned'),
                });

                return false;
            }

            axios.post('/api/decks/' + deck.id + '/buy').then(response => {
                if (response.data.success) {
                    iziToast.success({
                        message: response.data.message,
                        position: 'topRight',
                        messageColor: 'black !important',
                    });

                    this.fetchDeckList();
                    this.$forceUpdate();
                }
            });
        },
        getDiffInMinutes(shopItem) {
            let days = moment(shopItem.cooldown_until).diff(moment(), 'days');
            let hours = moment(shopItem.cooldown_until).diff(moment(), 'hours');
            let hoursInDay = hours - (days * 24);
            let minutes = moment(shopItem.cooldown_until).diff(moment(), 'minutes');
            let seconds = moment(shopItem.cooldown_until).diff(moment(), 'seconds');

            if (moment(shopItem.cooldown_until).diff(moment(), 'days') > 0) {
                return days + 'D' + hoursInDay + 'H';
            } else if (hours > 0) {
                return hours + 'H';
            } else if (minutes > 0) {
                return minutes + 'M';
            } else {
                return seconds + 'S';
            }
        },
        cooldownActive(shopItem) {
            if (!shopItem.cooldown_until) {
                return false;
            }

            return moment(shopItem.cooldown_until).diff(moment()) > 0;
        },
        checkForItemAction(shopItem) {
            if (shopItem.promo_card) {
                this.showCardCanvas(JSON.parse(shopItem.promo_card.json));
            }
        },
        showCardCanvas(card) {
            this.promoCardToShow = card;
            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 100)
        },
        getNextShopRefreshCooldown() {
            moment.locale((this.$i18n.locale));
            let now = moment();
            let cooldownTo = null;

            if (now.hour() >= 18) {
                cooldownTo = now.endOf('day');
            } else if (now.hour() >= 12) {
                cooldownTo = now.startOf('day').add(18, 'hours');
            } else if (now.hour() >= 6) {
                cooldownTo = now.startOf("day").add(12, 'hours');
            } else if (now.hour() >= 0) {
                cooldownTo = now.startOf("day").add(6, 'hours');
            } else {
                cooldownTo = moment();
            }

            return cooldownTo.fromNow();
        },
        fetchCollectionStatus() {
            axios.get('/api/collections/status').then(response => {
                this.collectionStatus = response.data;
            });
        },
        async fetchDeckList() {
            this.decks = await fetch('/api/decks').then(r => r.json())
        },
        shallDisplayShopItem(item, items) {
            let itemTypesInSet = items.map(setItem => setItem.item_type);

            return !(item.item_type === 'single-booster' && (
                itemTypesInSet.includes('single-booster-4') ||
                itemTypesInSet.includes('single-booster-5') ||
                itemTypesInSet.includes('single-booster-6') ||
                itemTypesInSet.includes('single-booster-7')
            ));
        }
    }
}
</script>

<style language="scss" scoped>
.page-heading {
    background-image: url(/assets/dipocaco/pocas/shop-poca_sm.jpg);
    background-position: center 38%;
}

.shop-item-image {
    height: 12em;
    margin: 0 0.5em;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.shop-item-image-folder-wrapper {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
    padding-top: 2em;
    padding-bottom: 0;

    .shop-item-image-folder {
        height: 10em;
        max-width: 12em;

        .shop-item-image {
            height: 10em;
            margin: 0 0;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
        }

        .booster-pack-container {
            position: relative;
            width: auto;
            height: 4em;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .booster-pack {
            position: absolute;
            height: 14em;
            width: auto;
            padding-top: 4em;
            transition: transform 0.3s;
        }

        .booster-center {
            z-index: 2;
            transform: translateX(0) rotate(0deg);
        }

        .booster-left {
            z-index: 1;
            transform: translateX(-50px) rotate(-20deg); /* Left one tilted and slightly left */
            margin-left: 0.1em;
        }

        .booster-right {
            z-index: 1;
            transform: translateX(50px) rotate(20deg); /* Right one tilted and slightly right */
            margin-right: 0.1em;
        }
    }
}

.shop-item-image:not(.shop-item-image-locked) {
    filter: drop-shadow(2px 4px 6px black);
}

.btn:not(.btn-sm) {
    margin-top: 1em;
    white-space: nowrap;
    width: 85% !important;
    padding: 0.5em 0.2em;
    border-radius: 25px;
}

.currency-icon {
    max-height: 1.5em;
    margin-top: -0.2em;
}

.shop-item-image-locked {
    filter: grayscale(1);
}

.item-description {
    text-align: center;
    display: block;
    padding: 0.5em 3em;
}

.collection-product-image {
    background-size: contain;
    padding: 2em;
    max-height: 20em;
}

.collection-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .collection-card-wrapper {
        height: 16em;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        .collection-booster-preview {
            background-size: contain;
            background-repeat: no-repeat;
            display: inline-block;
            height: 14.95em;
            width: 8.6em;
            margin-left: 0.5em;
            margin-right: 0.5em;
            vertical-align: top;
            text-align: right;

            .badge {
                background-color: black;
                color: white;
                font-weight: bold;
                font-size: 1rem;
                margin-left: 0.25em;
                margin-right: 0.25em;
            }
        }

        .collection-card-preview {
            background-size: contain;
            background-repeat: no-repeat;
            display: inline-block;
            height: 15.5em;
            width: 11em;
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
    }
}

.todays-collection-wrapper {
    max-width: 100%;
    overflow-x: auto;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: stretch;

    .todays-collection {
        min-width: 30em;

        &:not(:last-child) {
            margin-right: 1em;
        }
    }
}

.blisters .todays-collection {
    min-width: 30em;
}

.nav-item {
    font-size: 1.2em;
}

.language-icon {
    max-height: 1em;
    margin-top: -0.35em;
}

.deck-shop-wrapper {
    max-width: 100%;
    overflow-x: auto;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: stretch;

    .deck-card {
        display: inline-block;
        min-width: 30em;
        margin-bottom: 1em;

        &:not(:last-child) {
            margin-right: 1em;
        }

        .deck-product-image {
            max-height: 25em;
        }

        .deck-type-list {
            img:not(:last-child) {
                margin-right: .75em;
            }
        }

        .deck-cards-wrapper {
            max-width: 100%;
            overflow-x: auto;
            display: flex;
            flex-wrap: nowrap;
            flex-direction: row;
            align-items: stretch;

            a {
                display: inline-block;
                white-space: nowrap;
                margin-bottom: 1em;

                img {
                    width: 12em;
                }

                .badge {
                    background-color: black;
                    color: white;
                    font-weight: bold;
                    font-size: 1rem;
                    margin-left: -31px;
                    margin-right: 0;
                    margin-top: 0;
                }

                &:not(:last-child) {
                    margin-right: 1em;
                }
            }
        }
    }
}

</style>
